import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ScratchPaintRepair from './pages/services/ScratchPaintRepair';
import DentRepair from './pages/services/DentRepair';
import AlloyWheelRepair from './pages/services/AlloyWheelRepair';
import BumperRepair from './pages/services/BumperRepair';
import CeramicCoating from './pages/services/CeramicCoating';
import StoneChipTouchUp from './pages/services/StoneChipTouchUp';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/scratch-paint-repair" element={<ScratchPaintRepair />} />
          <Route path="/services/dent-repair" element={<DentRepair />} />
          <Route path="/services/alloy-wheel-repair" element={<AlloyWheelRepair />} />
          <Route path="/services/bumper-repair" element={<BumperRepair />} />
          <Route path="/services/ceramic-coating" element={<CeramicCoating />} />
          <Route path="/services/stone-chip-touch-up" element={<StoneChipTouchUp />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
